<template>
  <v-card>
    <v-card-title>
      Szczegóły zakolejkowanego powiadomienia
    </v-card-title>
    <v-card-text>
      <AddNotification
          :id="this.id"
      ></AddNotification>
    </v-card-text>
  </v-card>
</template>
<script>
import AddNotification from "@/components/notifications/AddNotification";

export default {
  props: {
    id: {
      type: [String],
      required: true,
    },
  },
  components: {
    AddNotification,
  },
}
</script>